import {LitElement, css, html} from 'lit';
import { customElement} from 'lit/decorators.js';

@customElement('voyage-time-popup-control')
export class VoyageTimePopupControl extends LitElement
{
    static get styles()
    {
        return [
            css`
            :host {
                display: flex;
                position: absolute;
                box-sizing: border-box;
                border-radius: 2px;
                border: 1px solid var(--neutrals-grey-06, grey);
                background-color: var(--neutrals-grey-10, white);
                filter: drop-shadow(0 0 5px rgba(0,0,0,0.25));
            }

            :host:after {
                content: "";
                box-sizing: border-box;
                position: absolute;
                height: 6px;
                width: 6px;
                transform: translateX(-50%) rotate(45deg);
                bottom: -3.5px;
                left: 50%;
                border-bottom: 1px solid var(--neutrals-grey-06, grey);
                border-right: 1px solid var(--neutrals-grey-06, grey);
                background-color: var(--neutrals-grey-10, white);
            }

            :host([darkarrow]):after {
                background-color: var(--neutrals-grey-07, grey);
            }
            `
        ];
    }

    render()
    {
        return html`
        <slot></slot>
        `;
    }
};
